export enum SelectedState {
  'ALL' = 'all',
  'INDETERMINATE' = 'indeterminate',
  'NONE' = 'none',
}

export type RawValue = string | number;

export interface DefaultContentType {
  id: string;
  label: React.ReactNode;
  disabled?: boolean;
  className?: string;
}
